import { render } from "./WalletBreakdownByExchange.vue?vue&type=template&id=25c67b42&scoped=true"
import script from "./WalletBreakdownByExchange.vue?vue&type=script&lang=js"
export * from "./WalletBreakdownByExchange.vue?vue&type=script&lang=js"

import "./WalletBreakdownByExchange.vue?vue&type=style&index=0&id=25c67b42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c67b42"]])

export default __exports__